import { DocumentServicesObject } from '@wix/document-services-types';
import { PlatformApiMethods } from '@wix/editor-platform-host-integration-apis';

const getSiteDimensions = (ds: DocumentServicesObject) => ({
  width: ds.site.getWidth(),
  height: ds.site.getHeight(),
});

type ISiteDimensionsChangeListener = (params: {
  width: number;
  height: number;
  isMobileView: boolean;
  siteScale: number;
}) => void;

const createSiteDimensionsStore = () => {
  const listeners: ISiteDimensionsChangeListener[] = [];

  let height: number = 0;
  let width: number = 0;
  let siteScale: number = 1;
  let isMobileView: boolean = false;

  return {
    set(params: {
      width: number;
      height: number;
      viewMode: string;
      siteScale: number;
    }) {
      height = params.height;
      width = params.width;
      siteScale = params.siteScale;
      isMobileView = params.viewMode === 'MOBILE';

      listeners.forEach((fn) =>
        fn({
          width,
          height,
          isMobileView,
          siteScale,
        }),
      );
    },
    register(cb: ISiteDimensionsChangeListener) {
      listeners.push(cb);

      cb({
        width,
        height,
        isMobileView,
        siteScale,
      });
    },
    get() {
      return { width, height };
    },
  };
};

export const siteDimensionsStore = createSiteDimensionsStore();

export const updateSiteDimensions = (
  hostApi: PlatformApiMethods,
  ds: DocumentServicesObject,
) => {
  siteDimensionsStore.set({
    ...getSiteDimensions(ds),
    siteScale: hostApi.editor.getSiteScale(),
    viewMode: ds.viewMode.get(),
  });
};
